// Fit the entire rotated PDF viewport inside the actual scrollable area.
export function pageRenderWidth(availableWidth, availableHeight, viewport, mode = 'page', zoom = 1) {
  const { width, height } = viewport;
  if (![availableWidth, availableHeight, width, height, zoom].every(value => Number.isFinite(value) && value > 0)) return 1;
  const base = mode === 'actual' ? width : mode === 'width' ? availableWidth : Math.min(availableWidth, availableHeight * width / height);
  return Math.max(1, Math.floor(base * zoom));
}
